import "./Main.css";
import BreadCrumb from "../breadcrumbs/Breadcrumbs";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import Dashboard from "../Dashboard/Dashboard";

const Main = () => {
  const currentUser = useSelector((state) => state?.auth?.user);

  if (!currentUser || currentUser?.Value?.roleName === "Onboarding Seller") {
    return <Navigate to="/login" />;
  }

  return (
    <main>
      <BreadCrumb name="Dashboard"></BreadCrumb>
      <div className="main__container">
        <Dashboard isEnabled={true} />
      </div>
    </main>
  );
};

export default Main;
